import { useState, useEffect } from "react";
import clsx from "clsx";
import { Link } from "react-router-dom";
import { routesFlat } from "@routes";
import { Button } from "../Button";

export default function CookiesPopup() {
    const [accepted, setAccepted] = useState(() => {
        // Check localStorage on initial render
        return !!localStorage.getItem("accepted_cookies");
    });

    useEffect(() => {
        // Also check on mount in case localStorage was set elsewhere
        const cookie = localStorage.getItem("accepted_cookies");
        if (cookie) {
            setAccepted(true);
        }
    }, []);

    const onAccept = () => {
        localStorage.setItem("accepted_cookies", "true");
        setAccepted(true);
    };

    if (accepted) {
        return null;
    }

    return (
        <div className={parentContainer}>
            <div>
                <div className={titleStyle}>we use cookies</div>
                <div className="mt-2">
                    CTrees uses cookies for measurement and analytics purposes.
                    For more details, or to learn how to opt out, please review
                    our{" "}
                    <Link to={routesFlat.privacy} className="underline">
                        Privacy Policy
                    </Link>
                    .
                </div>
                <div className="mt-2">
                    By using our website and products, you agree to our use of
                    cookies.
                </div>
            </div>
            <Button
                className="mt-4 w-40 lg:mt-2"
                primary={false}
                onClick={onAccept}
            >
                Accept
            </Button>
        </div>
    );
}

const parentContainer = clsx(
    "fixed bottom-0 left-0 z-[40] mb-10 md:ml-10 flex text-sm mx-4 md:w-[480px] ",
    "flex-col items-center rounded-xl bg-white p-8 shadow-sm",
);
const titleStyle = clsx(
    "text-center text-lg font-bold uppercase tracking-wider",
);
